import { FlexBox } from '@dixa/lib-shared-habla';

import { ButtonToggle } from './components/buttonToggle';
import { ViewMode } from './hooks/useBulletinEditor';

type FooterProps = {
  /** Is the bulletin able to be display the "Published" view mode? */
  canShowPublished: boolean;
  /** Current view mode */
  viewMode: ViewMode;
  /** Function that is triggered when view mode is changed */
  setViewMode: (viewMode: ViewMode) => void;
};

/** Renders the footer section of the bulletin board editor. */
export function Footer({
  canShowPublished,
  viewMode,
  setViewMode,
}: FooterProps): JSX.Element {
  if (!canShowPublished) {
    return <div />;
  }

  return (
    <FlexBox justifyContent="center" margin="32px">
      <ButtonToggle onChange={setViewMode} value={viewMode} />
    </FlexBox>
  );
}
